// extracted by mini-css-extract-plugin
export default {"chat":"Chat_chat__za7Fv","close":"Chat_close__a7RAK","forceLight":"Chat_forceLight__itZ3U"};